import * as React from "react"

import UploadConfiguration from "../../../deployment/components/export/UploadConfiguration"
import { IButton } from "../../../common/contextmenu"

interface Props {
    button: IButton
}

export default function ComponentButton({ button }: Props): JSX.Element {
    const { buttonData } = button

    if (buttonData.type !== "Component") {
        return <></>
    }

    switch (buttonData.componentName) {
        case "ExportPackage_UploadConfiguration":
            return <UploadConfiguration />

        default:
            return <></>
    }
}
